import { render, staticRenderFns } from "./SU9.vue?vue&type=template&id=0959a063&scoped=true&"
import script from "./SU9.vue?vue&type=script&lang=js&"
export * from "./SU9.vue?vue&type=script&lang=js&"
import style0 from "./SU9.vue?vue&type=style&index=0&id=0959a063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0959a063",
  null
  
)

export default component.exports